import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
export default {
  components: {
    Head: Head,
    Pagination: Pagination,
    SearchFilter: SearchFilter
  },
  layout: Layout,
  props: {
    filters: Object,
    campaigns: Object,
    tenatList: Object,
    campaignList: Object
  },
  data: function data() {
    return {
      form: {
        search: this.filters.search
      },
      showCampaignData: false,
      campaignData: {
        total_contacts: 0,
        total_companies: 0,
        follow_up_data: {},
        unique_companies: 0,
        untouched_contacts: 0,
        untouched_companies: 0,
        campaign_name: ''
      },
      emailData: {},
      showEmailData: false
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/campaign_activity/details', pickBy(this.form), {
          preserveState: true
        });
      }, 150)
    }
  },
  methods: {
    reset: function reset() {
      this.form = mapValues(this.form, function () {
        return null;
      });
    },
    getCampaignData: function getCampaignData(campaign) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.loading = true;
                _context.next = 3;
                return axios.post('/campaign_activity_data', {
                  tenantId: campaign.tenant_name,
                  campaignId: campaign.campaign_id
                });
              case 3:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.showCampaignData = true;
                  _this.campaignData = res.data.campaign_data;
                  _this.campaignData['campaign_name'] = campaign.campaign_name;
                } else {
                  alert(res.data.msg);
                }
                _this.$store.loading = false;
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getEmailData: function getEmailData(emailData) {
      this.emailData = emailData;
      this.showEmailData = true;
    }
  }
};